// @todo: separate into: Trie, linkOpener, csvParser, xhr, internalConsts; so React will package it
export const ROOT = {
  csvUrl: "https://lostrepo.github.io/duck.bangs/duck.csv",
  // 'test' will be replaced using queryRegexpToReplace
  defaultSearchEngineQuery: "https://www.google.com/search?q=",
  names: [],
  categories: [],
  duckUrls: [],
  queries: [],
  maxShownSuggestions: 64,
  showPartialMatchBangs: true,
  showPartialMatchUrls: true,
  groupSearchSeparator: "::::",
  nameIndex: 1,
  categoryIndex: 2,
  duckUrlIndex: 3,
  queryIndex: 4,
  bangIndex: 5,
  queryRegexpToReplace: /\{0\}|test|$/i,
  bangStartCharacter: "!",
  // dot is present on Android keyboard for 'text' input
  bangStartCharacterReplacement: "",
  log: console.log.bind(console),
  bangTrie: (function (prototype) {
    Object.defineProperty(prototype, "prototypeObject", {
      writable: false,
      enumerable: false,
      configurable: false,
      __proto__: null,
      value: prototype,
    });

    return Object.create(prototype);
  })(
    // Trie prototype
    Object.create(null, {
      chars: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: "",
      },
      value: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: null,
      },
      defaultLimit: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: 100000,
      },
      findNode: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars) {
          if (!chars) {
            return null;
          }

          var r = this;

          for (var i = 0; i < chars.length; i++) {
            r = r[chars[i]];
            if (!r) {
              return null;
            }
          }

          return r;
        },
      },
      find: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars) {
          if (!chars) {
            return null;
          }

          var r = this.findNode(chars);
          return r ? r.value : r;
        },
      },
      insertNode: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars) {
          if (!chars) {
            return null;
          }

          var r = this,
            tmp;

          for (var i = 0; i < chars.length; i++) {
            tmp = chars[i];
            // create node if doesn't exist already
            if (!r[tmp]) {
              Object.defineProperty(r, tmp, {
                enumerable: true,
                configurable: true,
                writable: false,
                __proto__: null,
                value: Object.create(this.prototypeObject),
              });
            }

            r = r[tmp];
          }

          return r;
        },
      },
      insert: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars, value) {
          if (!chars) {
            return null;
          }

          var r = this.insertNode(chars);

          // already defined, we don't allow redefining. fix bang data source
          if (r.chars) {
            console.log("Skip. Trie insert conflict:\n", [
              chars,
              value,
              r.value,
            ]);
            return null;
          }

          Object.defineProperties(r, {
            chars: {
              writable: false,
              enumerable: false,
              configurable: false,
              value: chars,
            },
            value: {
              writable: false,
              enumerable: false,
              configurable: false,
              value: value,
            },
          });

          return r.value;
        },
      },
      nodesWithPrefix: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars, limit) {
          if (!chars) {
            return null;
          }

          var root = this.findNode(chars);

          if (!root) {
            return null;
          }

          var toProcess = [root],
            r = Object.create(null, {
              length: {
                writable: true,
                enumerable: false,
                configurable: false,
                __proto__: null,
                value: 0,
              },
            });
          limit = +limit || this.defaultLimit;

          if (root.value) {
            r[root.chars] = root.value;

            if (++r.length > limit) {
              return r;
            }
          }

          // theoretically possible infinite loop, won't happen unless Trie logic modified
          while ((root = toProcess.shift())) {
            for (var k in root) {
              if (root[k]) {
                if (root[k].value) {
                  r[root[k].chars] = root[k];

                  if (++r.length > limit) {
                    return r;
                  }
                }

                toProcess.push(root[k]);
              }
            }
          }

          return r;
        },
      },
      nodesContaining: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars, limit) {
          if (!chars) {
            return null;
          }

          var r = Object.create(null, {
              length: {
                writable: true,
                enumerable: false,
                configurable: false,
                __proto__: null,
                value: 0,
              },
            }),
            l = chars.length,
            branches = [this],
            toAdd = [],
            tBranch = null;
          limit = +limit || this.defaultLimit;

          while (branches.length) {
            if ((tBranch = branches.shift())) {
              if (
                tBranch.chars.length >= l &&
                tBranch.chars.indexOf(chars) != -1
              ) {
                toAdd[0] = tBranch;

                while (toAdd.length) {
                  if ((tBranch = toAdd.shift())) {
                    if (tBranch.value) {
                      r[tBranch.chars] = tBranch;

                      if (++r.length > limit) {
                        return r;
                      }
                    }

                    for (var k in tBranch) {
                      toAdd.push(tBranch[k]);
                    }
                  }
                }

                continue;
              }

              // add sub branches
              for (var k in tBranch) {
                branches.push(tBranch[k]);
              }
            }
          }

          return r;
        },
      },
      valuesContaining: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars, limit) {
          if (!chars) {
            return null;
          }

          var r = Object.create(null, {
              length: {
                writable: true,
                enumerable: false,
                configurable: false,
                __proto__: null,
                value: 0,
              },
            }),
            l = chars.length,
            branches = [this],
            toAdd = [],
            tBranch = null;
          limit = +limit || this.defaultLimit;

          while (branches.length) {
            if ((tBranch = branches.shift())) {
              if (
                tBranch.chars.length >= l &&
                tBranch.chars.indexOf(chars) != -1
              ) {
                toAdd.push(tBranch);

                while (toAdd.length) {
                  if ((tBranch = toAdd.shift())) {
                    if (tBranch.value) {
                      r[tBranch.chars] = tBranch.value;

                      if (++r.length > limit) {
                        return r;
                      }
                    }

                    for (var k in tBranch) {
                      toAdd.push(tBranch[k]);
                    }
                  }
                }

                continue;
              }

              // add sub branches
              for (var k in tBranch) {
                branches.push(tBranch[k]);
              }
            }
          }

          return r;
        },
      },
      valuesWithPrefix: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars, limit) {
          if (!chars) {
            return null;
          }

          var root = this.findNode(chars);

          if (!root) {
            return null;
          }

          var toProcess = [root],
            r = Object.create(null, {
              length: {
                writable: true,
                enumerable: false,
                configurable: false,
                __proto__: null,
                value: 0,
              },
            });
          limit = +limit || this.defaultLimit;

          if (root.value) {
            r[root.chars] = root.value;

            if (++r.length > limit) {
              return r;
            }
          }

          // theoretically possible infinite loop, won't happen unless Trie logic modified
          while ((root = toProcess.shift())) {
            for (var k in root) {
              if (root[k]) {
                if (root[k].value) {
                  r[root[k].chars] = root[k].value;

                  if (++r.length > limit) {
                    return r;
                  }
                }

                toProcess.push(root[k]);
              }
            }
          }

          return r;
        },
      },
      listPrefixes: {
        writable: false,
        enumerable: false,
        configurable: false,
        __proto__: null,
        value: function (chars, limit) {
          if (!chars) {
            return null;
          }

          var nodes = this.nodesWithPrefix(chars, limit),
            r = [];

          for (var k in nodes) {
            r.push(k);
          }

          return r;
        },
      },
    })
  ),
  onenter: function (tags, query) {
    var queries = [];

    // run query
    if (query) {
      if (!tags.length) {
        return [
          this.defaultSearchEngineQuery.replace(
            this.queryRegexpToReplace,
            query
          ),
        ];
      }

      for (var i = 0; i < tags.length; i++) {
        var tmp = tags[i].url.split(this.groupSearchSeparator);
        for (var j = 0; j < tmp.length; j++) {
          queries.push(tmp[j].replace(this.queryRegexpToReplace, query));
        }
      }
    }
    return queries;
  },
  // @todo: validate url
  // @todo: needs more investigation
  openLink: /Safari[^\.0-9]+[\.0-9]+[0-9] .*$/.test(navigator.userAgent)
    ? // some weirdos
      function (url) {
        window.open(url, "about:blank", "noopener");
      }
    : // common mobile browsers
      function (url) {
        var link = document.createElement("a");
        link.setAttribute("rel", "noopener");
        link.setAttribute("target", "about:blank");
        link.setAttribute("href", url);
        link.click();
      },
  onChange: function (val, limit, fieldsToSearch) {
    var res = [];

    console.time("searchTime");
    limit = +limit || this.maxShownSuggestions;
    var chars = val.split(" ")[0],
      values = this.bangTrie.valuesWithPrefix(chars, limit);
    console.timeEnd("searchTime");

    var i = 0,
      tmp,
      name,
      category,
      duckUrl,
      query;

    if (values && values.length) {
      limit -= values.length;

      for (var k in values) {
        tmp = values[k];
        name = tmp[0];
        query = tmp[1];
        category = tmp[2];
        duckUrl = tmp[3];

        res.push({
          tag: k,
          name: this.names[name],
          category: this.categories[category],
          query: this.queries[query],
          duckUrl: this.duckUrls[duckUrl],
        });
      }
    }

    if (this.showPartialMatchBangs && limit > 0) {
      console.time("partialMatchSearchTime");
      var chars2 =
          chars[0] == this.bangStartCharacter ? chars.substring(1) : chars,
        values2 = this.bangTrie.valuesContaining(
          chars2,
          this.maxShownSuggestions - (values ? values.length : 0)
        );
      console.timeEnd("partialMatchSearchTime");

      if (values2 && values2.length) {
        limit -= values2.length;

        for (var k in values2) {
          // already
          if (values && k in values) {
            continue;
          }

          tmp = values2[k];
          name = tmp[0];
          query = tmp[1];
          category = tmp[2];
          duckUrl = tmp[3];

          res.push({
            tag: k,
            name: this.names[name],
            category: this.categories[category],
            query: this.queries[query],
            duckUrl: this.duckUrls[duckUrl],
          });
        }
      }
    }

    if (this.showPartialMatchUrls && limit > 0) {
      var length = (values && values.length) + (values2 && values2.length) || 0;
      values = Object.assign(values ? values : Object.create(null), values2);
      values.length = length;

      console.time("partialMatchUrlsSearchTime");
      var chars2 =
          chars[0] == this.bangStartCharacter ? chars.substring(1) : chars,
        values3 = this.queryTrie.valuesContaining(
          chars2,
          this.maxShownSuggestions - values.length
        );
      console.timeEnd("partialMatchUrlsSearchTime");

      if (values3 && values3.length) {
        limit -= values3.length;

        for (var k in values3) {
          var tmp3 = values3[k];

          for (var i = 0; i < tmp3.length; i++) {
            tmp = tmp3[i];
            k = tmp.chars;

            // already
            if (k in values) {
              continue;
            }

            tmp = tmp.value;
            name = tmp[0];
            query = tmp[1];
            category = tmp[2];
            duckUrl = tmp[3];

            res.push({
              tag: k,
              name: this.names[name],
              category: this.categories[category],
              query: this.queries[query],
              duckUrl: this.duckUrls[duckUrl],
            });
          }
        }
      }
    }

    return res;
  },
  onCsvParse: function (parsedCsv, ignoreFirstChar) {
    // this.log(parsedCsv);

    var l = parsedCsv.length,
      bangFormatError =
        "Skip. Bang must start with: " +
        this.bangStartCharacter +
        " at array index " +
        this.bangIndex,
      bangExistsError = "Skip. Bang already exists",
      nl = this.names.length,
      ql = this.queries.length,
      replaceStartChar =
        !ignoreFirstChar && !!this.bangStartCharacterReplacement,
      tmp,
      bang,
      name,
      category,
      duckUrl,
      query;

    for (var i = 1; i < l; i++) {
      tmp = parsedCsv[i];
      bang = tmp[this.bangIndex];

      // starts with correct character
      if (ignoreFirstChar || bang[0] == this.bangStartCharacter) {
        // we replace default start character with another one
        if (replaceStartChar) {
          bang = this.bangStartCharacterReplacement + bang.substring(1);
        }

        // bang doesn't exist yet
        if (!this.bangTrie.find(bang)) {
          category = tmp[this.categoryIndex] || "";
          duckUrl = tmp[this.duckUrlIndex] || "";
          name = tmp[this.nameIndex] || "";
          query = tmp[this.queryIndex] || "";

          if (query) {
            if (
              this.bangTrie.insert(bang, [
                nl++,
                ql++,
                (this.categories.indexOf(category) + 1 ||
                  this.categories.push(category)) - 1,
                (this.duckUrls.indexOf(duckUrl) + 1 ||
                  this.duckUrls.push(duckUrl)) - 1,
              ])
            ) {
              var qtEntry = this.queryTrie.find(query);
              if (qtEntry) {
                qtEntry.push(this.bangTrie.findNode(bang));
              } else {
                this.queryTrie.insert(query, [this.bangTrie.findNode(bang)]);
              }

              this.names.push(name);
              this.queries.push(query);
            } else {
              nl--;
              ql--;
            }
          } else {
            this.log("Skip. Empty query", tmp);
          }
        } else {
          this.log(bangExistsError, tmp);
        }
      } else {
        this.log(bangFormatError, tmp);
      }
    }
  },
  //
  defaultXhrTextHandler: function (errors, responseText) {
    if (errors.length) {
      return this.log(errors);
    }

    return this.csvParser(responseText);
  },
  // xhr text
  xhrText: function (url, cb) {
    var xhr = new XMLHttpRequest();
    cb = typeof cb == "function" ? cb : this.defaultXhrTextHandler.bind(this);

    xhr.open("GET", url, true);
    xhr.onerror = function (e) {
      return xhr.abort(), cb([e], "");
    };
    xhr.onload = function () {
      return cb([], xhr.responseText);
    };
    xhr.send(null);
  },
  // simple csv parser
  csvParser: function (s) {
    var res = [],
      i0 = -1,
      quoted = false,
      tmpAry = [];

    for (var i = 0; i < s.length; i++) {
      switch (s[i]) {
        // new value
        case ",":
          if (!quoted || s[i - 1] == '"') {
            tmpAry.push(s.substring(i0, i));
            quoted = false;
            i0 = i + 1;
          }
          continue;

        // new row
        case "\n":
          res.push(tmpAry);
          tmpAry = [];
          quoted = false;
          i0 = i + 1;
          continue;

        // quoted value
        case '"':
          quoted = !quoted;
          break;
      }
    }

    return this.onCsvParse(res);
  },
};
